import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IntegrationsStatus } from "../../../../../api/getIntegrationsStatus/types";
import { AppDispatch, AppThunk } from "../../../../../app/store";
import { getIntegrationsStatus } from "../../../../../api/getIntegrationsStatus/getIntegrationsStatusApi";

interface IntegrationsStatusState {
  integrationsStatus: IntegrationsStatus | null;
  loading: boolean;
  error: string | null;
}

const initialState: IntegrationsStatusState = {
  integrationsStatus: null,
  loading: false,
  error: null,
};

const integrationsStatusSlice = createSlice({
  name: "integrationsStatus",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setIntegrationsStatus: (
      state,
      action: PayloadAction<IntegrationsStatus>,
    ) => {
      state.integrationsStatus = action.payload;
    },
  },
});

export const { setLoading, setError, setIntegrationsStatus } =
  integrationsStatusSlice.actions;

export const fetchIntegrationsStatusAction =
  (shouldSetLoading = true): AppThunk =>
  async (dispatch: AppDispatch) => {
    if (shouldSetLoading) {
      dispatch(setLoading(true));
    }

    try {
      const response = await getIntegrationsStatus();
      dispatch(setIntegrationsStatus(response.data));
    } catch (error) {
      if (error instanceof Error) {
        dispatch(setError(error.message));
      } else {
        dispatch(setError("Failed to fetch integrations status"));
      }
    } finally {
      if (shouldSetLoading) {
        dispatch(setLoading(false));
      }
    }
  };

export default integrationsStatusSlice.reducer;